module.exports = __webpack_public_path__ + "junpintan.c256f9c2.png";